import { Box, Grid } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch, getSecureItem, setSecureItem } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import Loading from 'component/Loading'

/** STYLE */
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import { KEY_STORAGE } from 'constants/common'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import RemunerationDentistList from './RemunerationDentistList'
import ExportToExcel from './exportToExcel'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export default function RemunerationDentist() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const excelExportRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange
  const [selectedOptionPrice, setSelectedOptionPrice] = useState<any>(getSecureItem(KEY_STORAGE.REPORT_CONDITION) || 'TREATMENT')

  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)

  const [prefix, setPrefix] = useState('ALL')
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])

  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const [remuneraionDentistData, getRemuneraionDentistData] = useState<any[]>([])
  const [remuneraionDentistPage, setRemuneraionDentistPage] = useState<number>(1)
  const [remuneraionDentistLimitPage, setRemuneraionDentistLimitPage] = useState<number>(10)
  const [remuneraionDentistsecondPage, setRemuneraionDentistSecondPage] = useState<number>(10)
  const [remuneraionDentistTypePage, setRemuneraionDentistTypePage] = useState<number>(1)

  const [loading, setLoading] = useState<boolean>(true)
  const [checkDF, setCheckDF] = useState<boolean>(false)

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'REMUNERATION_ALL_DENTIST') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    ClinicApi.allBillPrefix()
      .then(({ data }) => {
        const filteredData = data.map((item: any) => ({ value: item.prefix, name: item.prefix }))
        setReceiptPrefix([...filteredData])
      })
      .catch((e) => {
        return
      })

    // โหลดรายชื่อหมอ ย้ายไป useEffect เดียวด้านล่าง (loader เดียว — กรองตามสาขา + ช่วงวันที่)

    // DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data: dataAllDoctor }) => {
    //   const dentists: DentistInterface[] = dataAllDoctor.map((d: any) => {
    //     return {
    //       dentistId: d.userId,
    //       dentistFullname: d.fullname
    //     }
    //   })
    //   // setDoctorsMultiple(dentists)
    //   setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
    // })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  // โหลดรายชื่อหมอ — loader เดียว กรองตามสาขา (branchId) + ช่วงวันที่ที่เลือก
  // ใส่ option "ไม่ระบุแพทย์" (999999) ในรายการเสมอ เพื่อให้ติ๊กเลือก + แสดงชื่อได้
  useEffect(() => {
    if (rangeDate[1] === 'Invalid date' || !rangeDate[1]) return
    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1], branchId)
      .then((resp) => {
        const dentists: DentistInterface[] = resp.data.map((d: any) => ({
          dentistId: d.userId,
          dentistFullname: d.fullname
        }))
        // Order matters (React 17 doesn't batch state updates inside .then):
        // setSelectDoctors must run BEFORE setDoctorsMultiple so that the auto-fetch
        // useEffect (which fires on doctorsMultiple.length going 0 → N) sees
        // selectDoctors with real doctor IDs — otherwise the initial fetch sends
        // an empty doctorId list and rowDf comes back empty.
        setDoctors([{ userId: 999999, firstname: '', lastname: '', fullname: t('REPORT.TITLE.NO_DOCTOR') }, ...resp.data])
        setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
        setDoctorsMultiple(dentists)
      })
      .catch((e) => {
        return
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, rangeDate[0], rangeDate[1]])

  const fetchRemunertationDentist = useCallback(() => {
    setLoading(true)
    let condition: FindAllReportInterface = {
      page: remuneraionDentistPage,
      pageLimit: remuneraionDentistLimitPage,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      optionPrice: selectedOptionPrice
    }

    if (selectDoctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }

    ReportApi.reportRemunerationAllDentist(condition)
      .then(({ headers, data }) => {
        getRemuneraionDentistData(data)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [branchId, remuneraionDentistLimitPage, remuneraionDentistPage, sortBy, sortType, remuneraionDentistsecondPage, remuneraionDentistTypePage, selectDoctors, prefix, rangeDate, selectedOptionPrice])

  // Auto-fetch once after the dentist list finishes loading, so the table
  // renders on page open without needing the user to click Search first.
  // Guarding on doctorsMultiple.length keeps the initial mount (when
  // selectDoctors is still ['ALL'] and would fetch with no doctorId) from
  // firing an empty request.
  useEffect(() => {
    if (doctorsMultiple.length === 0) return
    fetchRemunertationDentist()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctorsMultiple.length])


  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }
  const filter = [
    branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')}`,
    rangeDate[0],
    rangeDate[1],
    prefix === 'ALL' ? `${t(`REPORT.FILTER.ALL`)}` : prefix,
    _.isEmpty(selectDoctors)
      ? ` ${t('REPORT.FILTER.NO_SELECT')}`
      : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
        ? `${t('REPORT.FILTER.ALL')}`
        : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
          ?.map((d: any) => d.fullname)
          .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
          .join(', ')}`
  ]


  const exportExcel = async () => {
    setLoading(true);
    try {
      const branchName = branchId === 0
        ? t('REPORT.FILTER.ALL')
        : _.get(_.find(branches, { branchId }), 'branchName', '');
      await ExportToExcel({
        data: remuneraionDentistData,
        doctors: doctorsMultiple,
        filter: filter,
        filterDateStart: rangeDate[0],
        filterDateEnd: rangeDate[1],
        branchName: branchName,
        t: t,
      });
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    } finally {
      setLoading(false);
    }
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setRemuneraionDentistLimitPage(limit)

  const handleChangePage = (val: number) => setRemuneraionDentistPage(val)

  return (
    <Box sx={{ overflowX: 'unset' }}>
      <HeaderCard text={t(`REPORT.REPORT_NAME.REMUNERATION_ALL_DENTIST`)} />
      <Box padding="16px">
        <Box>
          <RadioButton
            name="radio-buttons-group"
            onChange={(e) => {
              setSecureItem(KEY_STORAGE.REPORT_CONDITION, e.target.value.toString())
              setSelectedOptionPrice(e.target.value)
            }}
            row
            sx={{ gap: '8px' }}
            value={selectedOptionPrice}
            options={[
              { label: t('REPORT.FILTER.PRICE_OF_TREATMENT'), value: 'TREATMENT', },
              { label: t('REPORT.FILTER.ACTUAL_PRICE_PAID'), value: 'PAID', }]}
          />
        </Box>
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={4} xl={2}>
            <SelectInput
              onChange={(e) => {
                setBranchId(e.target.value)
                setRemuneraionDentistPage(1)
              }}
              options={_.map(branches, (item) => ({ value: item.branchId, name: item.branchName || item.branchNameEn }))}
              value={branchId}
              defaultValue={`${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')} `}
              label={t('REPORT.FILTER.BRANCH')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={2}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                setRemuneraionDentistPage(1)
                setRemuneraionDentistTypePage(1)
              }}
              label={`${t('REPORT.TABLE.DECREASE.DATE_START')} » ${t('REPORT.TABLE.DECREASE.DATE_END')}`}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={2}>
            <SelectInput
              onChange={(e) => {
                setPrefix(e.target.value)
                setRemuneraionDentistPage(1)
                setRemuneraionDentistTypePage(1)
              }}
              options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') }, ...receiptPrefix]}
              value={prefix}
              label={t('REPORT.FILTER.RECEIPT_TYPE')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={2} onClick={() => {
            setCheckDF(!checkDF)
            setRemuneraionDentistPage(1)
            setRemuneraionDentistSecondPage(1)
          }}>
            <SelectCheckBoxInput
              label={t('USER_DOCTOR')}
              options={doctors.map((d: any) => ({
                id: d.userId,
                name: d.fullname
              }))}
              selected={selectDoctors}
              onChange={(ids: any) => {
                setSelectDoctors(ids)
                setOpenFilterDoctors(false)
              }}
              fullWidth
              width="100%"
              searchable
              searchPlaceholder={t('REPORT.FILTER.DOCTOR_SEARCH_PLACEHOLDER')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={8} xl={4}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <MainButton
                title={t('INPUT.SEARCH')}
                onClick={() => {
                  setRemuneraionDentistPage(1)
                  fetchRemunertationDentist()
                }}
                type={'primary'}
                variant={'contained'}
              />
              <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                if (e === 'Excel') exportExcel()
                if (e === 'PDF') {
                  const style = document.createElement("style");
                  style.innerHTML = `
                      @media print {
                        @page { size: landscape }
                        }
                    `;
                  document.head.appendChild(style);
                  window.print();
                  document.head.removeChild(style);
                }
              }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box padding="16px">
        <RemunerationDentistList
          page={remuneraionDentistPage}
          pageLimit={remuneraionDentistLimitPage}
          rowCount={rowCount}
          sortBy={sortBy}
          sortType={sortType}
          data={remuneraionDentistData}
          doctors={doctorsMultiple}
          onRequestSort={onRequestSort}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePage}
          filter={filter}
          filterDateStart={rangeDate[0]}
          filterDateEnd={rangeDate[1]}
          componentRef={componentRef}
        />
      </Box>
      <Loading show={loading} type="fullLoading" />
    </Box>
  )
}
